<template>
  <div class="row">
    <div v-if="customer" class="col-12">
      <Heading>
        {{ customer.name || customer.customer_number }} <span class="text-medium-gray">({{ customer.bottles.length }} Flasche<template
          v-if="customer.bottles.length !== 1">n</template>)</span>
      </Heading>
      <div class="border border-light p-5">

        <div class="row">

          <div class="col-4">
            <b class="text-primary">Standort:</b><br>
            {{ customer.address }},<br> {{ customer.postal }} {{ customer.city }}

          </div>
          <div class="col-4">
            <b class="text-primary">Telefonnummer:</b><br>
            {{ customer.phone || "-" }}
          </div>
          <div class="col-4">
            <b class="text-primary">E-Mail Adresse:</b><br>
            {{ customer.email || "-" }}
          </div>

          <div class="col-3 offset-9 text-right">
            <button @click="edit" class="btn btn-primary btn-block mt-5 btn-sm">Bearbeiten<i
                class="fas fa-pencil-alt pl-4"></i></button>
          </div>
        </div>
      </div>
      <list :items="customer.bottles" class="mt-5">
        <template v-slot:header>
          <div class="row">
            <div class="col-4">Flaschen Nummer</div>
            <div class="col-4">Typ</div>
            <div class="col-3">Fällig am</div>
          </div>
        </template>
        <template v-slot:itemTemplate="{item}">
          <div class="row align-items-center py-1">
            <!--						 <div class="col-12">{{item}}</div>-->
            <div class="col-4">
              Nr. {{ item.serial }}
            </div>
            <div class="col-4">
              {{ item.type }}
            </div>
            <div class="col-3">
              {{ dateWithFormat(item.due) }}
            </div>
            <div class="col-1">
              <button class="btn" @click="$router.push('/admin/bottles/'+item.id)">
                <i class="fas fa-chevron-right"></i>
              </button>
            </div>
          </div>
        </template>
      </list>
    </div>
  </div>
</template>

<script>
import Heading from "../../components/admin/Heading";
import {mapActions} from "vuex";
import BottleState from "../../components/admin/BottleState";
import List from "../../components/admin/List";
import timeFormatter from "../../mixins/timeFormatter";
import DataSelect from "../../components/DataSelect";

export default {
  name: "CustomerDetail",
  components: {DataSelect, Heading, BottleState, List},
  mixins: [timeFormatter],
  data() {
    return {
      customer: null
    }
  },
  mounted() {
    this.fetchCustomerDetails({id: this.$route.params.customer_id})
        .then(res => this.customer = res)
        .catch(this.apiErrorHandler)
  },
  methods: {
    ...mapActions({
      fetchCustomerDetails: "Api/Customers/get"
    }),
    edit() {
      this.$router.push(['', 'admin', 'customers', this.$route.params.customer_id, 'edit'].join(('/'))).catch(() => null);
    }
  }
}
</script>

<style scoped>

</style>
